import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import {
  IState,
  ISuccessAction,
  IFailureAction,
} from 'interfaces/paginate-duck';
import { ICarrierContact } from 'interfaces/carrier-contact';
const { Types, Creators } = createActions(
  {
    request: ['query'],
    success: ['data', 'pagination'],
    failure: ['error'],
    reset: [],
  },
  { prefix: 'PAGINATE_CARRIER_CONTACT_' }
);

export interface PaginateCarrierContactState extends IState {
  data: Record<string, any>[];
}

const INITIAL_STATE: PaginateCarrierContactState = {
  data: [],
  pagination: null,
  loading: false,
  error: null,
};

const request = (state: PaginateCarrierContactState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: PaginateCarrierContactState, action: ISuccessAction) =>
  update(state, {
    data: { $set: action.data },
    pagination: { $set: action.pagination },
    loading: { $set: false },
  });

const failure = (state: PaginateCarrierContactState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const paginateCarrierContact = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const PaginateCarrierContactTypes = Types;
export const PaginateCarrierContactActions = Creators;
